import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Solutions from './components/Solutions';
import References from './components/References';
import Footer from './components/Footer';
import Login from './components/admin/Login';
import AuthCallback from './components/admin/AuthCallback';
import AdminDashboard from './components/admin/AdminDashboard';
import KeyManager from './components/admin/KeyManager';
import ProtectedRoute from './components/admin/ProtectedRoute';
import Profile from './components/Profile';
import { useAuth } from './contexts/AuthContext';

function App() {
  const location = useLocation();
  const { loading } = useAuth();

  useEffect(() => {
    // Add loaded class when component mounts
    document.body.classList.add('loaded');
    
    // Header scroll effect
    const handleScroll = () => {
      const header = document.querySelector('header');
      if (header) {
        if (window.scrollY > 50) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    
    // Cleanup event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Admin sayfalarında header ve footer gösterme
  const isAdminRoute = location.pathname.startsWith('/admin') || 
                       location.pathname.startsWith('/auth');

  if (loading) {
    return <div className="loading">Yükleniyor...</div>;
  }

  return (
    <>
      {!isAdminRoute && <Header />}
      
      <Routes>
        {/* Ana site rotaları */}
        <Route path="/" element={
          <main>
            <Hero />
            <Services />
            <About />
            <Solutions />
            <References />
          </main>
        } />
        
        {/* Auth rotaları */}
        <Route path="/auth/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        
        {/* Profile route */}
        <Route path="/profile" element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        } />
        
        {/* Admin rotaları - korumalı */}
        <Route path="/admin" element={
          <ProtectedRoute adminOnly>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/admin/keys" element={
          <ProtectedRoute adminOnly>
            <KeyManager />
          </ProtectedRoute>
        } />
      </Routes>
      
      {!isAdminRoute && <Footer />}
    </>
  );
}

export default App; 